import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

export const TTCLabel = ({ className }: { className?: string }) => {
  return (
    <span className={clsx([s.label, className])}>
      <FormattedMessage id='ui.TTCLabel.inclVat' defaultMessage='TTC' />
    </span>
  )
}
